import { Injectable } from '@angular/core';
import { CanLoad, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { RequestManagementService } from '../services/request-management.service';
import { UserService } from '../services/user.service';

@Injectable()
export class AuthorizationGuard implements CanActivate {

    constructor(private requestManagementService: RequestManagementService, private usersService: UserService) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot)
        : Observable<boolean> | Promise<boolean> | boolean {
        //Pnina: TODO: Temporary hard code!!!
        //Pnina: TODO: Logged out users are not permitted to add new deal!
        if (next.routeConfig.path.startsWith('perm-error') || next.routeConfig.path.startsWith('deal-wizard') || next.routeConfig.path == 'login' || next.routeConfig.path == 'home' || this.usersService.isUserLoggedIn())
            return this.requestManagementService.loadConfiguration();
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/guards/authorization.guard.ts